import { Box, Button, Card, CardContent, Grid, Typography } from "@mui/material";
import { useAppSelector } from "../../store/hooks/useAppSelector";
import { RootState } from "../../store/types/rootState";
import { useGetRafflesQuery } from "../../store/api";
import { RaffleCard } from "./raffle-list/card";
import { IRaffle } from "../../store/interfaces/IRaffle";

export const RafflesList = () => {
  const accountInformation = useAppSelector(({ account }: RootState) => account);

  const { data: rafflesFounded = [], error: errorGetRaffles } = useGetRafflesQuery(undefined, {
    skip: accountInformation.id !== 'vip-rifas',
  });

  // Group raffles by accountId
  const rafflesByAccount = rafflesFounded.reduce<Record<string, IRaffle[]>>((acc, raffle) => {
    if (!acc[raffle.accountId]) {
      acc[raffle.accountId] = [];
    }
    acc[raffle.accountId].push(raffle);
    return acc;
  }, {});

  return (
    <Grid container spacing={2} sx={{ background: '#000', minHeight: '100vh', p: 2 }}>
      <Grid item xs={12}>
        <Typography variant="h4" color="white" fontWeight={"bold"} mb={2}>Rifas Activas</Typography>
        <Box display="flex" flexWrap="wrap" gap={3}>
          {rafflesFounded
            .filter(raffle => raffle.status === 'ACTIVE')
            .map((raffle) => (
              <RaffleCard key={raffle.id} raffle={raffle} />
          ))}
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Box>
          <Typography variant="h4" color="white" fontWeight={"bold"} mb={2}>Resumen de cuentas</Typography>
        </Box>
      </Grid>

      {/* Cards per account */}
      {Object.entries(rafflesByAccount).map(([accountId, raffles]) => {
        const totalRaffles = raffles.length;
        const activeRaffles = raffles.filter(raffle => raffle.status === 'ACTIVE').length;

        return (
          <Grid item xs={12} sm={6} md={4} key={accountId}>
            <Card sx={{ backgroundColor: '#1a1a1a', color: '#fff' }}>
              <CardContent>
                <Typography variant="h6" gutterBottom>{accountId}</Typography>
                <Typography variant="body1">Total Rifas: <strong>{totalRaffles}</strong></Typography>
                <Typography variant="body1">Rifas Activas: <strong>{activeRaffles}</strong></Typography>
              </CardContent>
            </Card>
          </Grid>
        );
      })}
    </Grid>
  );
};
